import { getLinkCoupon } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetLinkCouponServiceRequest,
  GetLinkCouponServiceRequestDtoSchema,
  type GetLinkCouponServiceResponse,
  GetLinkCouponServiceResponseDtoSchema,
} from './get-link-coupon.dto';

export const getLinkCouponService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetLinkCouponServiceRequestDtoSchema),
    async (request: GetLinkCouponServiceRequest): Promise<GetLinkCouponServiceResponse> => {
      const response = await getLinkCoupon(request);
      return response.data;
    },
    validateServiceResponse(GetLinkCouponServiceResponseDtoSchema),
  ),
);
